import React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import EventsList from '#component/general/simple-events/index';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

export const EventsListDialog = props => {
  const {
    open,
    account,
    handleClose,
    clickedEvents,
    history,
    isMobile,
    syncSelectedDevicesWithStore
  } = props;

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      fullScreen
      className="cluster"
    >
      <EventsList
        events={clickedEvents}
        history={history}
        account={account}
        closeList={handleClose}
        handleEventClick={() => {}}
        handleEventHover={() => {}}
        isMobile={isMobile}
        syncSelectedDevicesWithStore={syncSelectedDevicesWithStore}
      />
    </Dialog>

  );
};
